import * as React from 'react';

import type { IconProps } from '../../types';

/**
 * MensHealth icon
 *
 * @category Medical
 */
const MensHealth = React.forwardRef<SVGSVGElement, IconProps>(
  ({ 'data-testid': testId, size = 20, className, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        data-testid={testId}
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        role="img"
        aria-hidden="true"
        {...props}
      >
        <path
          fill="currentColor"
          d="M26.35 5.3c-2.02-.53-5.02-.13-7.21-.23-.52.03-1.15.05-1.52.36-.26.58 1.3.61 1.89.64 1.25.01 3.29-.01 4.44.02.72.03.96.13.73.47-1.04 1.22-3.7 3.75-5.22 5.29-.36.33-.72.62-1.16.71-.93.18-2.66-1.11-3.99-1.22-4.73-.95-9.43 2.98-9.31 7.79.51 11.4 17.21 9.91 15.71-1.4-.11-1.33-1.4-3.07-1.22-3.99.07-.38.3-.69.58-1.01 1.34-1.39 4.28-4.34 5.23-5.22.45-.38.59-.26.63.44.04 1.11.01 3.14.02 4.38.03.85 0 1.55.36 2.1.08.08.15.1.23.06.54-.6.37-1.62.41-3.19-.03-1.79.07-3.42-.07-4.92-.06-.42-.12-.76-.44-1l-.08-.05zM12.868 25.661c-8.55 0-8.84-13.1.234-13.1 8.782.7 8.317 13.1-.234 13.1"
        />
      </svg>
    );
  }
);

MensHealth.displayName = 'MensHealth';

export { MensHealth };
